import type { IssueCreditNoteResponse } from '@vy/api-definition';
import { IssueCreditNoteResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CreateCreditNoteFormValues } from '../../pages/credit-notes/CreateCreditNotePage/create-credit-note-page-components/CreateCreditNoteForm/CreateCreditNoteForm';

export function useCreateCreditNote(
  options?: UseMutationOptions<IssueCreditNoteResponse, unknown, CreateCreditNoteFormValues>,
) {
  return useMutation(async ({ customerId, ...payload }) => {
    const api = getPrivateApi();
    const issueCreditNoteResponse = await api.postCreditNote({
      customerId,
      issueCreditNoteRequest: payload,
    });

    return IssueCreditNoteResponseSchema.parse(issueCreditNoteResponse);
  }, options);
}
